export const GOOGLE_API_TOKEN = '579281480645-c7a2rg05shs4lrg39ckmvddpqcendp51.apps.googleusercontent.com';
export const SANITY_TOKEN = 'skivG6uTaLYGL0C6lDF4BCRkYzoRlAdCqAHYMS0zbIvWp65XGbVDIkwmFzXe80jITdcWnfXv90AxlgcyXvNFEsJVzJWWWxseHrvVdHXUmHCeWfnYD2HXF9BwGNaeqalRvfN9sbqvYPBR7IKMo0QdM5xLX6GCYSlj3B7v3zHGVjr8iiPAnZoo';
export const SANITY_PROJECT_ID = '2bfsfs7o';
